import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import './assets/css/style.css';
import HomeWorkHistory from './screens/HomeWorkHistory';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/homework-history" element={<HomeWorkHistory />} />
        <Route path="/" element={<HomeWorkHistory />} />
        {/* Other routes can be defined here */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
